import React, { useState, useEffect } from 'react';
import Breadcrumbs from '../common/Breadcrumbs';
import NewMailer from './NewMailer';
import Accordion from '../common/Accordion';
import { UserContext, MailerContext } from '../../hooks/Contexts';
import { userCan } from '../../helpers/rolePermissions';
import MailerListItem from './MailerListItem';
import { useLoaderData } from 'react-router-dom';
import { notify } from '../../helpers/notifications';
import { sortByAlpha } from '../../helpers/sorters';

const MailersIndex = () => {
  const { data } = useLoaderData();
  const {
    current_user,
    permission,
    form,
    fieldsets,
    metadata_entries,
    related_forms,
  } = data;
  const { container } = form;

  // fieldsets prop is structured [{ fieldset, fields: [] }, ...]
  // TODO restructure this ^^^ maybe
  const [mailers, setMailers] = useState(sortByAlpha(form.mailers, 'name'));
  const [isCreating, setIsCreating] = useState(false);
  const user = { ...userCan(current_user, permission) };

  const toggleCreating = () => setIsCreating(!isCreating);
  const handleScanMailers = () => {
    let scan = mailers.filter(
      (m) => m.scan_for_invalid_bodies?.body_is_invalid
    );
    if (scan.length) {
      notify.alertFailure(
        'Issues were found!',
        `${scan.length} mailer${scan.length > 1 ? 's' : ''} require${
          scan.length == 1 ? 's' : ''
        } attention before sending.`
      );
    } else {
      notify.success('Mailers scan successful', { showOnlyTheLastOne: false });
    }
  };

  useEffect(() => {
    handleScanMailers();
  }, [mailers]);

  return (
    <UserContext.Provider value={user}>
      <MailerContext.Provider
        value={{ form, fieldsets, metadata_entries, related_forms }}
      >
        <Breadcrumbs
          form={{ name: form.name, id: form.id }}
          container={{ name: container.name, id: container.id }}
        />

        <div>
          <section className='mailers'>
            <h2>Mailers</h2>

            {user.isAdmin && (
              <Accordion
                id='new-mailer-dropdown'
                expanded={isCreating}
                toggle={toggleCreating}
                additionalClass={'lower-control-space'}
              >
                <NewMailer
                  toggleCreating={toggleCreating}
                  setMailers={setMailers}
                />
              </Accordion>
            )}
          </section>
          <div className='mailers'>
            <table>
              <thead>
                <tr>
                  <th>Mailer Name</th>
                  <th className='small'>Send on Submit?</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {!mailers.length ? (
                  <tr className='empty'>
                    <td colSpan='100%'>There are no mailers for this form.</td>
                  </tr>
                ) : (
                  mailers.map((mailer, i) => {
                    return (
                      <MailerListItem
                        mailer={mailer}
                        key={mailer.id}
                        setMailers={setMailers}
                      />
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div id='context-menu-wrapper' />
      </MailerContext.Provider>
    </UserContext.Provider>
  );
};

export default MailersIndex;
